import React, {Component} from 'react';
import marketStyle from '../css/marketsBaseball.css';
import OddsCardBaseball from './oddsCardBaseball';
import {getText} from "../../../../../helpers/localization";

class UnderOverCombine extends Component {

    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        let underOverMarkets = [];
        for (let i = 0; i < markets.length; i += 2) {
            underOverMarkets.push(<div className={marketStyle.marketGroup} key={i}>
                <div className={marketStyle.scoreGroupUnderOverLabel}>
                    <div className={`${marketStyle.marketLabelMedium} ${marketStyle.marketLabel}`}>
                        <span>{markets[i+1].selection.split("_")[1]+"."+markets[i+1].selection.split("_")[2]}</span>
                    </div>
                </div>
                <div
                    className={`${marketStyle.underOverPrefix} ${marketStyle.marketLabel}`}>{getText('OVER_SHORT', store)}</div>
                <div className={marketStyle.scoreGroupUnderOverOdds}>
                    <OddsCardBaseball store={store} market={markets[i]}/>
                </div>
                <div
                    className={`${marketStyle.underOverPrefix} ${marketStyle.marketLabel}`}>{getText('UNDER_SHORT', store)}</div>
                <div className={marketStyle.scoreGroupUnderOverOdds}>
                    <OddsCardBaseball store={store} market={markets[i+1]}/>
                </div>
            </div>);
        }

        return (
            <div>
                {underOverMarkets}
            </div>
        );
    }

}

export default UnderOverCombine;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/components/underOverCombine.js